import { getLocaleString } from "utils/localization/locale";
import mapValues from "lodash/mapValues";

export const DISPUTE_LIST_COLUMNS = {
  [getLocaleString("common.dispute_id", "Dispute ID")]: true, // Added Dispute ID column
  [getLocaleString("common.status", "Status")]: true,
  [getLocaleString("common.title", "Title")]: true,
  [getLocaleString("common.description", "Description")]: true,
  [getLocaleString("common.customer", "Customer")]: true,
  [getLocaleString("common.assigned_to", "Assigned To")]: true,
  [getLocaleString("common.priority", "Priority")]: true,
  [getLocaleString("dispute.level", "Level")]: true,
  [getLocaleString("common.dispute_type", "Type")]: true,
  [getLocaleString("common.workflow", "Workflow")]: true,
  [getLocaleString("common.created_date", "Created Date")]: true,
  [getLocaleString("common.amount", "Amount")]: true,
  [getLocaleString("common.supporting_documents", "Documents")]: true,
};

let i = 1;
export const initialDashboardDisputeColumnsOrder = mapValues(
  DISPUTE_LIST_COLUMNS,
  () => i++
);

export const initialDisputeFilters = {
  search: "",
  dispute_status: "",
  dispute_type: "",
  assigned_to: "",
  dispute_priority: "",
  nextPage: null,
  prevPage: null,
  page: 1,
  sort_by: "created_date",
  sort_order: "desc",
};

export const DISPUTE_FILTERS_MORE_FIELDS = [
  {
    key: "customer",
    labelKey: "common.customer",
    defaultLabel: "Customer",
    type: "text",
  },
  {
    key: "invoice",
    labelKey: "common.invoice",
    defaultLabel: "Invoice",
    type: "text",
  },
  {
    key: "case_owner",
    labelKey: "dispute.case_owner",
    defaultLabel: "Case Owner",
    type: "text",
  },
  {
    key: "created_date",
    labelKey: "common.created_date",
    defaultLabel: "Created Date",
    type: "date",
  },
  {
    key: "dispute_amount",
    labelKey: "dispute.amount",
    defaultLabel: "Dispute Amount",
    type: "float",
  },
];
